export enum EndPoints {
    GET_RESOURCES = '/resources/selling',
    GET_CATEGORIES = '/categories/all',
    POST_RESOURCES = '/resources/create',
    CLASSES_UPLOADED = '/classes/uploaded',
    CLASSES_PURCHASED = '/classes/purchased'
}